import { useEffect, useState } from "react";
import { Descriptions } from "antd";
import PropTypes from "prop-types";

/** Below Tailwind `md` (768px), edit fields stack label over input (one DOM tree — avoids duplicate Form.Items). */
function useStackedEditFieldLayout() {
    const [stacked, setStacked] = useState(() =>
        typeof window !== "undefined" ? window.innerWidth < 768 : true,
    );

    useEffect(() => {
        const mq = window.matchMedia("(min-width: 768px)");
        const update = () => setStacked(!mq.matches);
        update();
        mq.addEventListener("change", update);
        return () => mq.removeEventListener("change", update);
    }, []);

    return stacked;
}

const MOBILE_EDIT_FIELD_SHELL =
    "min-w-0 space-y-4 [&_.ant-form-item]:!mb-0 [&_.ant-input]:!m-0 [&_.ant-input]:!h-10 [&_.ant-input]:!rounded-lg [&_.ant-input]:!border [&_.ant-input]:!border-[#d9d9d9] [&_.ant-input]:!bg-white [&_.ant-input]:!px-3 [&_.ant-input]:!shadow-none [&_.ant-input-affix-wrapper]:!rounded-lg [&_.ant-picker]:!w-full [&_.ant-picker]:!rounded-lg [&_.ant-select]:!w-full [&_.ant-select-selector]:!rounded-lg [&_textarea.ant-input]:!h-auto [&_textarea.ant-input]:!py-2";

function CarDetailEditFieldTable({ rows, title, column = 1 }) {
    const stacked = useStackedEditFieldLayout();

    return (
        <div className="mx-4 mb-4 min-w-0">
            {title && <h3 className="fontbold mb-3 text-base text-[#121212]">{title}</h3>}

            {stacked ? (
                <div className={MOBILE_EDIT_FIELD_SHELL}>
                    {rows.map((row) => (
                        <div key={String(row.label)} className="flex min-w-0 flex-col gap-1.5">
                            <span className="text-sm font-medium text-[#121212]">{row.label}</span>
                            <div className="min-w-0 w-full">{row.content}</div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="min-w-0 overflow-x-auto">
                    <Descriptions
                        column={column}
                        size="small"
                        bordered
                        className="car-detail-descriptions min-w-[280px]">
                        {rows.map((row) => (
                            <Descriptions.Item key={String(row.label)} label={row.label} span={row.span || 1}>
                                {row.content}
                            </Descriptions.Item>
                        ))}
                    </Descriptions>
                </div>
            )}
        </div>
    );
}

CarDetailEditFieldTable.propTypes = {
    rows: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.node.isRequired,
            content: PropTypes.node.isRequired,
            span: PropTypes.number,
        }),
    ).isRequired,
    title: PropTypes.string,
    column: PropTypes.number,
};

export default CarDetailEditFieldTable;
